import { render, staticRenderFns } from "./AddPeriodDialog.vue?vue&type=template&id=3982162c&scoped=true&"
import script from "@/views/Periods/AddPeriodDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/Periods/AddPeriodDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Periods/add-period-dialog.scss?vue&type=style&index=0&id=3982162c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3982162c",
  null
  
)

export default component.exports